export const totalEntradas = (reportes) => {
  let total = 0;
  let cantidad = 0;
  let concurrencia = 0;
  let ausentes = 0;

  reportes.data.map((re) => {

    total = parseFloat(re.cantidad * re.unidad) + total;
    cantidad = parseInt(re.cantidad) + cantidad;

    if (re.reporte_codigo.length > 0) {
      re.reporte_codigo.map((rc) => {
        if (rc.ingreso == "ESPERA") {
          ausentes += 1;
        }
        if (rc.ingreso == "CONCURRIO") {
          concurrencia += 1;
        }
      });
    } else {
      if (re.registro_cliente == "CONCURRIO") {
        concurrencia += 1;
      }

      if (re.registro_cliente == "ESPERA") {
        ausentes += 1;
      }
    }
  });

  return {
    total,
    cantidad,
    concurrencia,
    ausentes,
  };
};

export const tipoEntrada = (reportes) => {
  let tipoEntrada = [
    {label: 'TODOS', value: 'TODOS'}
  ];
  

  reportes.map((re) => {
   console.log(re);
    if (tipoEntrada.filter((te) => te.value == re.entrada?.id).length > 0) {
    } else {
      tipoEntrada.push(
       {label: re.entrada?.nombre, value: re.entrada?.id});
    }
  });

  return tipoEntrada;
};
